<template>
  <div class="newsInfo">
    <div class="newsDiv">
      <p class="news_title">{{ newsData.title }}</p>
      <p class="news_time">发布时间 : {{ newsData.newstime }}</p>
      <div class="fenge_line"></div>
      <!-- 富文本内容 -->
      <div class="news_contextdiv" v-html="newsData.context"></div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'newsInfo',
  data() {
    return {
      newsID:null,
      newsData:{}
    }
  },
  created() {
    this.newsID = this.$route.query.newsID;
    this.getData(this.newsID);
  },
  methods:{
    getData(id){
      let _this = this;
      this.$axios.get('/fantis/news/ftCmsNews/queryById?id='+id)
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result;

            if(tempData.headimg.startsWith('//') || tempData.headimg.startsWith('https://') || tempData.headimg.startsWith('http://')){

            }else{
              tempData.headimg = _this.$fileDPath + tempData.headimg;
            }

            _this.newsData = tempData;

          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    }
  }
}
</script>

<style scoped>
.newsDiv{
  width: 100%;
  height: auto;
  box-sizing: border-box;padding: 2% 20% 2% 20%;
}
.news_title{
  text-align: center;
  font-size: 20px;
  color: #333;
  line-height: 1.5;
}
.news_time{
  text-align: center;
  font-size: 13px;
  color: #999;
  opacity: 0.6;
  -moz-opacity: 0.6;
  filter: alpha(opacity = 60);
  line-height: 1;
  margin: 0 0 20px 0;
}
.fenge_line{
  width: 100%;
  border: 0.2px solid #d3d3d3;
}
.news_contextdiv{
  width: 100%;
  height: auto;
  margin-top: 15px;
}
.newsBtndiv{
  width: 100%;
  height: auto;
  box-sizing: border-box;
  border-bottom: 0.2px solid #d3d3d3;
  border-top: 0.2px solid #d3d3d3;
}
</style>



// WEBPACK FOOTER //
// src/components/views/news/newsInfo.vue